// extracted by mini-css-extract-plugin
export default {"wrapper":"CopyableCode_wrapper__5+PWs","code":"CopyableCode_code__V1z1K","copyBtn":"CopyableCode_copyBtn__Nd7g0"};